import React, { forwardRef, useMemo } from 'react';
import cx from 'classnames';
import { ArrowDownV2 } from '../../../../icons/index.js';
import { useWindowSize } from '../../../../../utils/hooks/useWindowSize.js';
import styles from './index.module.scss.js';

const ThumbV2 = forwardRef(
  ({
    text,
    isActive,
    thumbLabel,
    disabled,
    formType,
    image,
    roundIcon,
    value: additionalValue,
    iconForMobile,
    ...props
  }, forwardedRef) => {
    const { windowSize } = useWindowSize();
    const isAdaptive = useMemo(() => windowSize.width <= 1200, [windowSize]);
    const value = useMemo(() => {
      if (!text) return "";
      const splitted = text.split(",");
      if (splitted.length === 1)
        return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles.value }, text), "\xA0", /* @__PURE__ */ React.createElement("div", { className: styles["add-value"] }, additionalValue));
      return /* @__PURE__ */ React.createElement("div", { className: styles.value }, splitted[0], " + ");
    }, [text, additionalValue]);
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        ...props,
        type: "button",
        disabled,
        className: cx(styles.box, "thumb-v2", {
          [styles["form-type"]]: formType,
          [styles["round-icon"]]: roundIcon,
          [styles.active]: isActive,
          [styles["only-icon-for-mobile"]]: isAdaptive && iconForMobile
        }),
        ref: forwardedRef
      },
      !isAdaptive || isAdaptive && !iconForMobile ? /* @__PURE__ */ React.createElement(React.Fragment, null, image && typeof image === "string" && /* @__PURE__ */ React.createElement("img", { className: styles.image, src: image, alt: image }), image && typeof image !== "string" && /* @__PURE__ */ React.createElement("div", { className: styles["image-svg"] }, image), /* @__PURE__ */ React.createElement("div", { className: styles.text }, thumbLabel), "\xA0", value, " ", /* @__PURE__ */ React.createElement(
        ArrowDownV2,
        {
          className: cx(styles["arrow-icon"], {
            [styles.active]: isActive
          })
        }
      )) : /* @__PURE__ */ React.createElement(React.Fragment, null, iconForMobile && typeof iconForMobile === "string" && /* @__PURE__ */ React.createElement(
        "img",
        {
          className: cx(styles.image, styles["icon-for-mobile"]),
          src: iconForMobile,
          alt: ""
        }
      ), iconForMobile && typeof iconForMobile !== "string" && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cx(styles["image-svg"], styles["icon-for-mobile"])
        },
        iconForMobile
      ))
    );
  }
);
ThumbV2.displayName = "Popup.ThumbV2";

export { ThumbV2 };
//# sourceMappingURL=index.js.map
